import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/moldspotcheck`,
    name: 'MOLD_SPOTCHECK_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
